

export const IMAGE_STRING: string = 'image';

export const IMAGE_EXTENSIONS: string[] = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'bmp',
    'webp',
    'svg',
    'tiff',
    'ico'
];

export const AUDIO_STRING: string = 'audio';

export const AUDIO_EXTENSIONS : string[] = [
            'mp3',
            'wav',
            'ogg',
            'm4a',
            'flac'
        ];


export const VIDEO_STRING: string = 'video';

export const VIDEO_EXTENSIONS : string[] = [
    'mp4',   // El estándar de facto (H.264/AAC)
    'webm',  // Formato abierto (VP8/VP9, Opus/Vorbis)
    'ogv',   // Ogg Video (Theora/Vorbis)
    'mov'   // Apple QuickTime (Soporte variable, común pero no universal)
];

export const TEXT_STRING: string = 'text';

export const TEXT_EXTENSIONS : string[] = [
    'txt',
    'log',
    'md'
];

export const PDF_STRING: string = 'pdf'; 

export const PDF_EXTENSIONS : string[] = [
    'pdf'
];

export const EXCEL_STRING: string = 'excel'; 

export const EXCEL_EXTENSIONS : string[] = [
    // Microsoft Excel (Formatos más comunes y recientes)
    'xlsx', // Excel Workbook (más común)
    'xlsm', // Excel Macro-Enabled Workbook
    'xls',  // Formato antiguo de Excel (pre-2007)

    // OpenDocument Format (OpenOffice/LibreOffice)
    'ods'   // OpenDocument Spreadsheet
];

export const CSV_STRING: string = 'csv'; 

export const CSV_EXTENSIONS : string[] = [
    'csv',    // Comma Separated Values (el más común)
    'tsv',    // Tab Separated Values
];

export const WORD_STRING: string = 'word'; 

export const WORD_EXTENSIONS : string[] = [
    // Microsoft Word (Formatos más comunes y recientes)
    'docx', // Word Open XML Document (más común)
    'docm', // Word Macro-Enabled Document
    'doc',  // Formato antiguo de Word (pre-2007)
    
    // OpenDocument Format (OpenOffice/LibreOffice)
    'odt',  // OpenDocument Text
    
    // Rich Text Format (formato de texto enriquecido simple)
    'rtf'
];

export const ARCHIVE_EXTENSIONS: string[] = [
  'zip', 'rar', '7z', 'tar', 'gz'
];

// Definición de tipos para el mapa de iconos
export interface FileIconMap {
  [key: string]: string;
}


/**
 * Función para generar el mapa final de extensión a icono.
 */
function generateFileIconMapping(): FileIconMap {
  const mapping: FileIconMap = {};

  // Función auxiliar para poblar el mapa
  const populateMap = (extensions: string[], icon: string) => {
    extensions.forEach(ext => {
      // Mapeamos con el punto inicial para coincidir con la convención del ejemplo
      mapping['.' +ext] = icon; 
    });
  };

  // --- Mapeo de Grupos a Iconos de Material Design ---

  // Imágenes
  populateMap(IMAGE_EXTENSIONS, 'image');

  // Audio/Video (Usamos el mismo icono de "Reproducir" o "Media" para simplicidad)
  populateMap([...AUDIO_EXTENSIONS, ...VIDEO_EXTENSIONS], 'play_circle_outline');

  // PDF
  populateMap(PDF_EXTENSIONS, 'picture_as_pdf');

  // Hojas de Cálculo y Datos Estructurados (CSV, XLSX, JSON)
  populateMap([...EXCEL_EXTENSIONS, ...CSV_EXTENSIONS], 'table_view');

  // Documentos (DOCX, ODT) y Texto Plano (TXT)
  populateMap([...WORD_EXTENSIONS, ...TEXT_EXTENSIONS], 'description');

  // Archivos Comprimidos
  populateMap(ARCHIVE_EXTENSIONS, 'archive');


  // Se puede agregar un valor por defecto o se gestiona en la función de acceso
  mapping['default'] = 'insert_drive_file'; // Si necesitas la llave 'default'
  
  return mapping;
}

// --- CONSTANTE DE EXPORTACIÓN FINAL ---
// Esta es la variable que importarás en tus componentes
export const FILE_ICON_MAPPING: FileIconMap = generateFileIconMapping();


export const ALL_ALLOWED_EXTENSIONS: string[] = [
    ...IMAGE_EXTENSIONS,
    ...AUDIO_EXTENSIONS,
    ...VIDEO_EXTENSIONS,
    ...TEXT_EXTENSIONS,
    ...PDF_EXTENSIONS,
    ...EXCEL_EXTENSIONS,
    ...CSV_EXTENSIONS,
    ...WORD_EXTENSIONS
];

/**
 * Valida si un archivo tiene una extensión permitida.
 * @param file El objeto File a validar.
 * @returns true si la extensión es válida, false en caso contrario.
 */
export function isValidExtension(file: File): boolean {
    if (!file || !file.name) {
        return false;
    }

    // 1. Obtener la extensión del archivo
    const fileName = file.name;
    const lastDotIndex = fileName.lastIndexOf('.');

    // Si no hay punto o el punto está al principio/final, asumimos que no hay extensión válida
    if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) {
        return false;
    }

    // Extraer la extensión y convertirla a minúsculas
    const extension = fileName.substring(lastDotIndex + 1).toLowerCase();

    // 2. Comprobar si la extensión está en la lista de permitidas
    return ALL_ALLOWED_EXTENSIONS.includes(extension);
}

// Genera el contenido del Popover
export function popoverContent(): string {
    
    // Convertir a una lista de extensiones separadas por coma
    const extensionsText = ALL_ALLOWED_EXTENSIONS.join(', ').toUpperCase();

    return `
      **Tipos de archivos permitidos:**<br>
      ${extensionsText}<br>
      <br>
      **Tamaño máximo:**<br>
      Menos de 50 MB.
    `;
    
  }